import React from 'react';
import { render } from '@testing-library/react';
import { Link } from './Link';

describe('Link', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should be an anchor element if href attribute exists', () => {
		const { getByRole } = render(
			<Link href="https://v1.anvil.servicetitan.com">Website</Link>
		);

		const link = getByRole('link');

		expect(link).not.toHaveAttribute('type');
		expect(link.tagName).toBe('A');
	});

	it('should be a button element if no href attribute exists', () => {
		const { getByRole } = render(<Link onClick={() => {}}>Website</Link>);

		const link = getByRole('link');

		expect(link).not.toHaveAttribute('type', 'button');
		expect(link.tagName).toBe('BUTTON');
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Link
				href="https://v1.anvil.servicetitan.com"
				data-auto-sel="automation-selector"
			>
				Website
			</Link>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
